import { render, staticRenderFns } from "./Consegne.vue?vue&type=template&id=fff80e82&"
import script from "./Consegne.vue?vue&type=script&lang=js&"
export * from "./Consegne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports